<template>
  <div>
    <app-login
        v-if="showLogin"
        @loggedIn="loggedIn"
    />
    <div v-else id="app">
      <MenuHeader
          @logout="logout"
      />
      <div class="container">
        <router-view/>
      </div>
    </div>
  </div>
</template>

<script setup>
</script>

<script>
import MenuHeader from "@/components/MenuHeader.vue";
import AppLogin from "@/layouts/AppLogin.vue";
import {eventBus} from "@/eventBus";

export default {
  name: 'App',
  components: {
    MenuHeader,
    AppLogin,
  },
  data () {
    return {
      showLogin: true,
    }
  },
  created() {
    const token = this.getToken()
    if (token) {
      this.showLogin = false
    } else {
      if (this.$route.name !== 'root') {
        this.$router.push({name: 'root'})
      }
    }
  },
  mounted() {
    eventBus.$on("apiError", this.showApiError);
    eventBus.$on("logout", this.logout);
  },
  beforeUnmount() {
    eventBus.$off("apiError", this.showApiError);
    eventBus.$off("logout", this.logout);
  },
  methods: {
    loggedIn () {
      this.showLogin = false
      this.$router.push({name: 'hr-bot'})
    },
    showApiError(msg) {
      const text = msg || 'Ошибка запроса'
      this.$bvToast.toast(text, {
        title: 'Error',
        autoHideDelay: 3000,
        variant: "danger"
      })
    },
    getToken() {
      return localStorage.getItem('token')
    },
    logout () {
      localStorage.removeItem('token')
      localStorage.removeItem('userId')
      this.$router.push({name: 'root'})
      this.showLogin = true
    }
  }
}
</script>

<style>
*, *::before, *::after {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
  color: #021505;
  font-size: 16px;
  font-family: 'Arial', sans-serif;
  line-height: 2rem;
}

a {
  text-decoration: none;
}

#app {
  background-color: #fbfff8;
  min-height: 100vh;
}

.container {
  max-width: 1200px !important;
  margin: 0 auto;
  width: 100%;
}

.mt-30 {
  margin-top: 30px;
}

.mb-30 {
  margin-bottom: 30px;
}

.mt-20 {
  margin-top: 20px;
}

.text-right {
  text-align: right;
}

.pointer {
  cursor: pointer;
}

.font-14 {
  font-size: 14px;
}

.hidden {
  position: absolute;
  top: -1000px;
  left: -1000px;
  display: none;
  visibility: hidden;
  width: 0;
  height: 0;
  overflow: hidden;
}
</style>
